// src/middleware/persistToCookies.ts
import { PersistStorage, StorageValue } from 'zustand/middleware';
import { AuthState } from '../store/authStore.js';

const cookieStorage: PersistStorage<AuthState> = {
  getItem: async (name) => {
    const value = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`))
      ?.split('=')[1];
    return value ? (JSON.parse(value) as StorageValue<AuthState>) : null;
  },
  setItem: (name, value) => {
    document.cookie = `${name}=${JSON.stringify(value)}; path=/`;
  },
  removeItem: (name) => {
    document.cookie = `${name}=; Max-Age=0; path=/`;
  },
};

export default cookieStorage;
